import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { ui } from 'components';
import HOCs from 'components/HOCs';
import FiltersForm from './FiltersForm';

import './style.scss';

const FORM_NAME = 'addProductForm';

const AddProductForm = ({
  handleSubmit,
  filters,
}) => (
  <form onSubmit={handleSubmit} className="add-product-form">
    <div className="add-product-form__row">
      <div className="add-product-form__column">
        <Field
          component={ui.Fields.BaseField}
          name="name"

          props={{
            label: '* Имя',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="code"

          props={{
            label: '* Код',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="price"

          props={{
            label: '* Цена',
          }}
        />
        <Field
          component={ui.Fields.TextareaField}
          name="description"

          props={{
            label: 'Описание',
          }}
        />
        <Field
          component={ui.Fields.TextareaField}
          name="material"

          props={{
            label: 'Материал',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="density"

          props={{
            label: 'Плотность',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="img"

          props={{
            label: 'Изображение (название)',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="saleAmount"

          props={{
            label: 'Размер скидки',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="confirmation"
          props={{
            label: '* Код подтверждения',
          }}
        />
      </div>
      <div className="add-product-form__column">
        <FieldArray
          name="properties.series"
          component={FiltersForm}

          props={{
            filters: filters.series,
            label: '* Серия',
            single: true,
          }}
        />
        <FieldArray
          name="properties.category"
          component={FiltersForm}

          props={{
            filters: filters.category,
            label: '* Категория',
            single: true,
          }}
        />
        <FieldArray
          name="properties.size"
          component={FiltersForm}

          props={{
            filters: filters.size,
            label: '* Размер',
          }}
        />
        <FieldArray
          name="properties.color"
          component={FiltersForm}

          props={{
            filters: filters.color,
            label: '* Цвет',
          }}
        />
      </div>
    </div>
    <div className="add-product-form__button">
      <ui.Buttons.BaseButton
        style={{
          fontSize: 12,
        }}
        title="добавить"
      />
    </div>
  </form>
);

AddProductForm.propTypes = {
  filters: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default compose(
  HOCs.FormErrorsHandlerHOC(),

  reduxForm({
    form: FORM_NAME,
    initialValues: {
      properties: {
        size: [''],
        color: [''],
        category: [''],
        series: [''],
      },
    },
  }),
)(AddProductForm);



// WEBPACK FOOTER //
// ./src/components/forms/AddProductForm/index.js